<script setup>
import { defineProps, watch } from 'vue'
import { offLineRecordConf, isShowValue } from './DetailConf'
import ImageWithName from '@/components/ImageWithName'
const props = defineProps({
  dInfo: {
    type: Object,
    default: () => {}
  },
  infoBase: {
    type: Object,
    default: () => {}
  }
})
watch(
  () => props.infoBase,
  n => {
    offLineRecordConf.DRUG_INFO.forEach(item => {
      if (item.type === 'drug') {
        // noMedication :0-用药 1-暂无用药
        item.isShow = n.noMedication == 0 ? true : false
      }
    })
  }
)
</script>
<template>
  <div class="offLine_DInfo">
    <!-- <h3 class="baseTitle">药品信息</h3> -->
    <div class="content">
      <template v-for="(item, index) in offLineRecordConf.DRUG_INFO" :key="item.label + index">
        <div v-if="item.isShow" :class="item?.class + 'Label'" class="contentItem">
          <div>
            <span class="label" v-if="item.type !== 'img'">{{ item.label }}：</span>
            <span>
              <span v-if="item.type == 'img' && item.prop == 'imgUrlList'">
                <span class="label">{{ item.label }}</span>
                <div
                  class="item_content img_content"
                  v-if="
                    infoBase &&
                    infoBase.imgUrlList &&
                    infoBase.imgUrlList.length &&
                    isShowValue(infoBase, true)
                  "
                >
                  <a-row>
                    <div class="img-container">
                      <ImageWithName :fileList="infoBase.imgUrlList" />
                    </div>

                    <!-- <div class="recordImg" v-for="(img, imgdex) in infoBase.imgUrlList" :key="imgdex">
                    <auth-img mode='ant' alt="病历图片" width="100%" height="100%" :src="img" />
                  </div> -->
                  </a-row>
                </div>
                <span v-else>：--</span>
              </span>
              <span v-else-if="item.prop == 'ocrImgUrlList'">
                <span class="label">{{ item.label }}</span>
                <div class="item_content img_content" v-if="infoBase && infoBase.ocrImgUrlList">
                  <a-row>
                    <div class="img-container">
                      <ImageWithName :fileList="infoBase.ocrImgUrlList" />
                    </div>
                  </a-row>
                </div>
                <span v-else>：--</span>
              </span>
              <span v-else>
                <span v-if="['description', 'medicationNames'].includes(item.prop)">
                  {{ item.render(infoBase) }}
                </span>
                <span v-else>
                  {{ dInfo ? item.render(infoBase, dInfo, dInfo[item.value]) : '--' }}
                </span>
              </span>
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.offLine_DInfo {
  ::v-deep(.ant-image-img) {
    object-fit: cover;
  }
  .baseTitle {
    font-size: 16px;
    font-weight: 550;
    color: #000000;
    margin-bottom: 25px;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  .contentItem {
    width: 33%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .label {
      color: #333333;
      font-weight: 550;
    }
  }
  .lLabel {
    width: 100%;
  }

  .img_content {
    display: flex;
    margin: 0;
    .img-container {
      margin-top: 8px;
    }
    .recordImg {
      width: 140px;
      height: 120px;
      overflow: hidden;
      margin: 4px 12px 12px 0;
    }
  }
}
</style>
